require('./_wks-define')('asyncIterator');



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/~/core-js/modules/es7.symbol.async-iterator.js